import type React from 'react';
import * as styles from './BreadcrumbSlash.css';

export const BreadcrumbSlash: React.FC = () => {
  return <span className={styles.slash}>/</span>;
};
